export const programmingConst = {
  path: "/single-programs/programming",
  title: "ФАКУЛЬТЕТ ИТ И ИНЖЕНЕРИИ – ПРОГРАММИРОВАНИЕ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Программирование — профессия, формирующая цифровое будущее</h2>
      <p>
        Современный мир невозможно представить без программного обеспечения. От мобильных приложений до сложных информационных систем — за
        всем стоят программисты. Эта программа даёт не только технические навыки, но и учит проектному мышлению, командной работе и созданию
        цифровых решений под реальные бизнес-задачи.
      </p>
      <p>
        Студенты осваивают как фундаментальные, так и актуальные языки программирования, получают опыт разработки, тестирования и
        сопровождения программного обеспечения.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Алгоритмы и структуры данных</li>
        <li>Языки программирования (Python, Java, C++, JavaScript и др.)</li>
        <li>Объектно-ориентированное и функциональное программирование </li>
        <li>Разработка мобильных и веб-приложений</li>
        <li>Работа с базами данных и SQL</li>
        <li>Разработка интерфейсов (UI/UX)</li>
        <li>Тестирование и обеспечение качества кода</li>
        <li>DevOps и облачные технологии</li>
        <li>Командная разработка (Git, Agile, SCRUM)</li>
        <li>Искусственный интеллект и машинное обучение (по выбору)</li>
      </ul>
      <p>Вся программа ориентирована на практику: от первых строк кода до реальных проектов с портфолио.</p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Программист / разработчик программного обеспечения</li>
        <li>Фронтенд- или бэкенд-разработчик</li>
        <li>Full-stack инженер</li>
        <li>Специалист по тестированию и автоматизации</li>
        <li>Инженер по данным / ML-инженер</li>
        <li>Разработчик мобильных приложений</li>
        <li>DevOps-инженер или системный архитектор</li>
        <li>Разработчик игр или AR/VR-продуктов</li>
      </ul>
      <h2>Средний доход в Европе:</h2>
      <p>
        от <strong>€55,000 до €110,000 в год,</strong> в зависимости от специализации и опыта.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Программа обновляется под требования рынка</li>
        <li>Европейский диплом, признанный международными ИТ-компаниями</li>
        <li>Работа над реальными проектами, стажировки, участие в хакатонах</li>
        <li>Обучение с нуля — не нужен опыт программирования</li>
        <li>Возможность выбрать трек: веб-разработка, ИИ, мобильные приложения, игры</li>
        <li>Учёба на русском или английском языке</li>
        <li>Гибкий формат: очно или полностью онлайн</li>
      </ul>
      <p>Программирование — это навык XXI века, который открывает неограниченные карьерные возможности.</p>
      <h2>Как поступить?</h2>
      <p>
        Наша приёмная комиссия поможет вам на каждом шаге: от подачи заявки до выбора специализации и получения визы (при необходимости).
      </p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Программирование — профессия, формирующая цифровое будущее
    Современный мир невозможно представить без программного обеспечения. От мобильных приложений до сложных информационных систем — за всем стоят программисты. Эта программа даёт не только технические навыки, но и учит проектному мышлению, командной работе и созданию цифровых решений под реальные бизнес-задачи.
    Студенты осваивают как фундаментальные, так и актуальные языки программирования, получают опыт разработки, тестирования и сопровождения программного обеспечения.

    Что вы будете изучать?
    • Алгоритмы и структуры данных
    • Языки программирования (Python, Java, C++, JavaScript и др.)
    • Объектно-ориентированное и функциональное программирование
    • Разработка мобильных и веб-приложений
    • Работа с базами данных и SQL
    • Разработка интерфейсов (UI/UX)
    • Тестирование и обеспечение качества кода
    • DevOps и облачные технологии
    • Командная разработка (Git, Agile, SCRUM)
    • Искусственный интеллект и машинное обучение (по выбору)
    Вся программа ориентирована на практику: от первых строк кода до реальных проектов с портфолио.

    Кем можно работать после окончания?
    • Программист / разработчик программного обеспечения
    • Фронтенд- или бэкенд-разработчик
    • Full-stack инженер
    • Специалист по тестированию и автоматизации
    • Инженер по данным / ML-инженер
    • Разработчик мобильных приложений
    • DevOps-инженер или системный архитектор
    • Разработчик игр или AR/VR-продуктов

    Средний доход в Европе:
    от €55,000 до €110,000 в год, в зависимости от специализации и опыта.

    Почему выбирают нас?
    • Программа обновляется под требования рынка
    • Европейский диплом, признанный международными ИТ-компаниями
    • Работа над реальными проектами, стажировки, участие в хакатонах
    • Обучение с нуля — не нужен опыт программирования
    • Возможность выбрать трек: веб-разработка, ИИ, мобильные приложения, игры
    • Учёба на русском или английском языке
    • Гибкий формат: очно или полностью онлайн

    Программирование — это навык XXI века, который открывает неограниченные карьерные возможности.

    Как поступить?
    Наша приёмная комиссия поможет вам на каждом шаге: от подачи заявки до выбора специализации и получения визы (при необходимости).
  `,
};
